import { Upload } from 'antd';
import styled from 'styled-components';
const MicrosoftUploadStyle = styled(Upload)`
  margin-left: 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const UploadIcon = styled.img`
  width: 20px;
  height: 20px;
`;

export { MicrosoftUploadStyle, UploadIcon };
